import {
  LanguageId,
  MPSellerApi,
} from "@efood-commerce-sdk/typescript-axios-transaction-efood";
import { site } from "_foundationExt/constants/site";
import ensureObject from "tools/ensureObject";

const mpSellerApiInstance = new MPSellerApi(undefined, site.transactionContext);

const marketplaceService = {
  /**
   * Retrieves a list of marketplace sellers for the specified store.
   * @param parameters {storeId: string}
   */
  getMPSellersForStore(parameters: { storeId: string; langId: string }) {
    const { storeId, langId } = ensureObject(parameters);

    return mpSellerApiInstance.getMPSellersForStore(
      storeId,
      langId as LanguageId
    );
  },
};

export default marketplaceService;
